import SigninHandler from '../components/signinHandler';
import {cacoo} from "../components/cacoo";
const isSigninPage = $('body').hasClass('page--signin');
const isInvitationSignin = $('body').hasClass('page--invitation-signin');

if(isSigninPage) {
  require('velocity-animate');
  let Spinner = require('spin');
  let cacoo = require('../components/cacoo').cacoo;
  class Signin {
    constructor() {
      this.cacoo = require('../components/cacoo').cacoo;

      this.serviceMap = {
        'twitter':'Twitter'
        , 'facebook':'Facebook'
        , 'google':'Google'
        , 'google-apps': 'Google Apps'
      };

      let signinHandler = new SigninHandler("signinForm");
      this.$googleAppButton = $('.js_toggle-google-apps-form', signinHandler.body);
      this.$googleAppForm = $('#signin_apps', signinHandler.body);
      this.$accountForm = $('.account-form', signinHandler.body);
      this.switchToLogin = $('.js_switch_account', this.$accountForm);
      this.$nulabLogin = $('.account-form__body-inner_nulabLogin', this.$accountForm);
      this.$nulabButton = $('.account-form__button' , this.$nulabLogin);
      this.$loadingScreen = $('.account-form__loading', signinHandler.body);
      this.buttonSpinner = new Spinner({color: '#74758b', lines: 12});
      this.$securityDevice= $('.js_security-device', this.$accountForm);
      this.$errorMessage = $('.error-message', signinHandler.body);

      this.$annotation = $('.forms-introduction__subheading', signinHandler.body);
      this.$introduction = $('.forms-introduction__heading', signinHandler.body);

      this.buttonSpinner.spin(this.$loadingScreen.get(0));

      if(!isInvitationSignin) {
        this.loadNulabJS();
      }

      // Check migration error on url params
      const connectedEmail = this.cacoo.util.getUrlParameter('connected');
      if(connectedEmail) {
        const migrationError = this.cacoo.util.getResourceWithArg(Cacoo.SiteResources['signin_migration_error'], [connectedEmail]);
        this.$errorMessage.html(migrationError).show();
        signinHandler.email.val(connectedEmail);
        signinHandler.password.focus();
      }

      const signinEmail = this.cacoo.util.getUrlParameter('email');
      if (signinEmail) {
        signinHandler.email.val(signinEmail);
        signinHandler.password.focus();
      }

      this.attachEvent();
    }

    loadNulabJS() {
      $.ajax({
        url: `${window.Cacoo.settings.nulabAccountBaseUrl}/launchbox/js/v2/launchbox.js`,
        dataType: 'script',
        timeout: 3000
      }).done(() => {
          let lb = new NulabLaunchBox(Cacoo.settings.nulabAccountBaseUrl);
          lb.getEmailIfSigned((email) => {
            $('span', this.$nulabButton).html(email);
            this.$accountForm.addClass('-nulabLogin');
            this.removeLoadingScreen();
          }, () => {
            this.removeLoadingScreen();
          });
        })
        .fail((jqxhr, settings, exception) => {
          console.error(`Error on load Nulab Account script: ${exception}`);
          this.removeLoadingScreen();
      });

      this.switchToLogin.on('click', () => {
        this.$accountForm.removeClass('-nulabLogin');
        this.$nulabLogin.fadeOut('fast');
      });

      if (cacoo.util.getUrlParameter("existingAccount") === "true") {
        const next = `${Cacoo.settings.baseUrl}/team/try`
        this.$nulabButton.attr("href", this.$nulabButton.attr("href") + '?next=' + encodeURIComponent(next));
        this.$securityDevice.attr("href", `${this.$securityDevice.attr("href")}?next=${encodeURIComponent(next)}`);
      } else {
        let next = cacoo.util.getUrlParameter("next");
        if (next !== undefined) {
          this.$nulabButton.attr("href", this.$nulabButton.attr("href") + '?next=' + encodeURIComponent(next));
          this.$securityDevice.attr("href", `${this.$securityDevice.attr("href")}?next=${encodeURIComponent(next)}`);
        }
      }

      let consent = cacoo.util.getUrlParameter("consent");
      if (consent !== undefined) {
        this.$nulabButton.attr("href", this.$nulabButton.attr("href")
                               + ((this.$nulabButton.attr("href").indexOf('?') == -1) ? '?' : '')
                               + 'consent=' + encodeURIComponent(consent));
      }

      let backFrom = cacoo.util.getUrlParameter("backFrom");
      let serviceName = this.serviceMap[backFrom];
      if (serviceName !== undefined) {
        let resource = cacoo.util.getResourceWithArg(Cacoo.SiteResources['signup_via_3rd_service_error'], [serviceName]);
        this.$annotation.html(resource).addClass('error-message');
        this.$introduction.remove();
      } else {
        this.$annotation.remove();
      }
    }

    removeLoadingScreen() {
      this.$loadingScreen.fadeOut('fast', () => {
        this.$loadingScreen.remove();
      });
    }

    attachEvent() {
      this.$googleAppButton.on('click', (e) => {
        e.preventDefault();
        let opacity = 0;
        let display = 'none';
        if(this.$googleAppForm.css("opacity") === '0') {
          opacity = 1;
          display = 'block';
        }

        this.$googleAppForm.velocity({opacity: opacity}, {display: display}, {duration: 200});
      });


    }
  }

  new Signin();
}
